'use strict';

// export this package's api
module.exports = require('./Animate');


//////////////////
// WEBPACK FOOTER
// ./~/rc-animate/lib/index.js
// module id = 78
// module chunks = 0